import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { report } from '../api/orderService'
import { Dialog } from 'antd-mobile'
import Main from './components/Main'
import { getThemeConfig, ThemeConfig } from '../utils/themeConfig'
import { Center, Loader } from '@mantine/core'

export default function Report() {
  const navigate = useNavigate()
  let { orderId } = useParams()
  const [data, setData] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [themeConfig, setThemeConfig] = useState<ThemeConfig>()

  useEffect(() => {
    if (orderId === '') {
      navigate('/error')
    }
    const fetchData = async (retryDelays = [3000, 2000, 2000, 3000, 5000, 5000, 5000], attempt = 0) => {
      report(orderId!)
        .then((res) => {
          setData(res.data)
          setIsLoading(false)
          setThemeConfig(getThemeConfig((res.data as any).templateThemeType as number))
        })
        .catch((error) => {
          if (error.errorCode === 1011) {
            if (attempt < retryDelays.length) {
              setTimeout(() => fetchData(retryDelays, attempt + 1), retryDelays[attempt])
            } else {
              Dialog.alert({
                content: '报告生成中，请返回报告列表手动刷新查看或者联系客服处理。',
                onConfirm: () => {
                  navigate('/orders')
                },
              })
            }
          }
        })
    }
    fetchData().then()
  }, [navigate, orderId])

  if (isLoading || !themeConfig) {
    return (
      <Center h="100vh">
        <Loader color="#5087EB" size="lg" type="dots" />
      </Center>
    )
  }

  return <Main data={data} isLoading={isLoading} theme={themeConfig} />
}
